module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/ideal-payment-card-7b35866230d10349e836cace19cffcb0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/ideal-payment-card.svg
// module id = AHtK
// module chunks = 24